import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { DevelopmentFeedFragment, Kfh_DevelopmentResalePropertyType } from '../types/graphqlTypes';
import { PROPERTY_URLS } from '../urls';
import { startWithSlash } from '../utils/startWithSlash';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { DevelopmentListPropertyCard } from './properties/DevelopmentListPropertyCard';
import { Section } from './Section';

interface DevelopmentFeedProps extends DevelopmentFeedFragment {
  width: 'narrow' | 'wide';
}

// JSX

export const DevelopmentFeed: FC<Omit<DevelopmentFeedProps, '__typename'>> = ({
  title,
  backgroundColour,
  developments,
  width,
}) => {
  // Resale Property Count
  const { developmentPropertyData } = useStaticQuery(graphql`
    query developmentPropertyQuery {
      developmentPropertyData: allKfhDevelopmentResalePropertyType {
        totalCount
      }
    }
  `);

  if (!developments.properties.edges) {
    return null;
  }

  const { totalCount } = developmentPropertyData;
  const heading = title || `We have ${totalCount} new developments across London.`;

  return (
    <Section
      background={backgroundColour ? backgroundColour.replace('1', '') : 'white'}
      contained
      overflowHidden
      narrow={width === 'narrow'}
      customButton={{
        label: 'View all developments',
        url: startWithSlash(PROPERTY_URLS.developmentProperties),
        arrowRight: true,
      }}
    >
      <CardCarouselWrapper heading={heading} width={width}>
        {developments.properties.edges.map(({ node }, index) => (
          <DevelopmentListPropertyCard
            property={node as unknown as Kfh_DevelopmentResalePropertyType}
            key={index}
            vertical
            disableGallerySwipeOnMobile
          />
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
